import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { socialLoginRedirectUrl } from '../Common/Providers/SocialLoginApi';
import config from '../../config';
import { hasSpinner } from '../../src/Common/Spinner';
import { openRedirectUrl } from './SocialLoginHelper';

function toSocialLogin(provider, props) {
  socialLoginRedirectUrl(provider)
    .done((response) => {
      openRedirectUrl(response.data.redirect_url, props);
    }, 'json')
    .fail((response) => {
      if ('string' === typeof response.responseJSON.errors) {
        toastr.error(
          response.responseJSON.errors, '',
          { 'positionClass': 'toast-bottom-full-width' }
        );
      }
    });
}

const facebookButton = (props) => (
  <div className="form-group text-center">
    <button type="button" className="btn-block btn facebook-button" onClick={() => toSocialLogin('facebook', props)} id="fbLoginButton">
      <span className="fa fa-facebook pr-4"></span>{props.text}</button>
  </div>
);

const googleButton = (props) => (
  <div className="form-group text-center">
    <button type="button" className="btn-block btn google-button" onClick={() => toSocialLogin('google', props)} id="googleLoginButton">
      <img className="google-icon pr-4" src={`${config.s3BucketUrl}/logos/googleLogo.svg`} />
      <span className="pr-3">{props.text}</span></button>
  </div>
);

const mapStateToProps = state => ({
   isItEditorPage: state.currentPageName == 'editor' ? true : false,
   isItAnniversaryLandingPage: state.productPagePath && state.productPagePath.indexOf('anniversary') > -1
});

const enhance = compose(
  hasSpinner,
  connect(mapStateToProps)
);

export const ContinueWithGoogle = enhance(googleButton);
export const ContinueWithFacebook = enhance(facebookButton);


// WEBPACK FOOTER //
// ./src/Account/SocialLoginButtons.js